import { Component } from '@angular/core';
import { OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ConfigService } from '../../services/config.service';
import { UserService } from '../../services/user.service';
import { SaveSearchComponent } from '../save-search/save-search.component';
import { SearchService } from '../../search/services/search.service';

/**
 * Component for displaying user search history.
 */
@Component({
	selector: 'search-history',
	templateUrl: './search-history.component.html',
	styleUrl: './search-history.component.css'
})
export class SearchHistoryComponent implements OnInit, OnDestroy {
	
	private userEventSubscription!: Subscription;
	private searchEventSubscription!: Subscription;
	
	LOCALIZATION: any;

	searchHistory: any[] = [];
	loggedin: boolean = false;

	constructor(
		private ngbModal: NgbModal,
		private userService: UserService,
		private searchService: SearchService,
		private configService: ConfigService
	) {
		this.LOCALIZATION = this.userService.LOCALIZATION;
		this.loggedin = this.userService.user.loggedin;
	}

	ngOnInit(): void {
		this.searchEventSubscription = this.searchService.broadcastEvent.subscribe(event => {
		    if (event.type === 'searchEnded') {
				console.log('Search Ended event received!');
				this.loadUserSearchHistory();
		    }
		});
		
		this.userEventSubscription = this.userService.broadcastEvent.subscribe((event: string) => {
			if ('localizationLoaded' === event) {
				this.LOCALIZATION = this.userService.LOCALIZATION;
			}
		});

		this.loadUserSearchHistory();
	}
	
	ngOnDestroy() {
		if (this.userEventSubscription) {
			this.userEventSubscription.unsubscribe();
		}
				
	    if (this.searchEventSubscription) {
	        this.searchEventSubscription.unsubscribe();
	    }
	}	

	/**
	 * Loads the user's search history for the current session.
	 */
	loadUserSearchHistory(): void {
		let maxHistory = this.configService.getConfig().advancedSearchPanel.savedSearches.history.maxDisplay;

		this.searchService.getUserSearchHistory(true).then(
			(data: any) => {
				this.searchHistory = data.slice(0, maxHistory);
			},
			(err: any) => {
				console.error("Failed to fetch user's search history", err);
				this.searchHistory = [];
			}
		);
	}

	/**
	 * Executes a recent search.
	 */
	executeHistorySearch(historyObj: any, event?: Event): void {
		if (event) event.stopPropagation();

		let searchObj = this.searchService.getSearchObjectFromHistory(historyObj);
		searchObj.data = JSON.stringify(searchObj.data);

		let data = {
			searchObj: searchObj,
			notify: false
		};

		//			    if ($scope.mapDetached) {
		//			        data['broadcastSync'] = true;
		//			    }

		this.searchService.broadcastSearchEvent(data);
	}

	/**
	 * Saves a search from the current session into the user's
	 * saved searches list.
	 */
	saveHistorySearch(historyObj: any, event?: Event): void {
		if (event) event.stopPropagation();

		let searchObj = this.searchService.getSearchObjectFromHistory(historyObj);
		let saveSearchObj = JSON.stringify({
			aoi: searchObj.data.aoi,
			query: searchObj.data.query,
			criteria: searchObj.data.criteria,
			type: searchObj.data.type
		});

		const modalRef = this.ngbModal.open(SaveSearchComponent, {
			size: 'md'
		});

		modalRef.componentInstance.mode = "add";
		modalRef.componentInstance.searchData = saveSearchObj;
		modalRef.componentInstance.savedSearch = null;

		modalRef.result.then(
			(payload) => {
				if (payload.result?.answer === 'ok') {
					//					this.loadSavedSearches(); // TODO
				}
			},
			(reason) => {
				console.log('Modal dismissed');
			}
		);
	}
}